<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="keypadForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Code, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Code, 'label')">{{ 'CODE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Code, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputMTMKBKeyCode"
							formControlName="Code" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'CODE' | translate }}" maxlength="12" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Code)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'KEYPAD_CODE_WARNING_INVALID' |
					translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.Description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputMTMKBKeyDesc"
							formControlName="Description" placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Description)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Action1, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Action1, 'label')">{{ 'ACTION1' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Action1, 'borderInput')">
						<p-dropdown [options]="mtmaActions" optionLabel="Traslation" [ngClass]="dynamicInputTextWidth()"
							appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							panelStyleClass="text-center" formControlName="Action1" placeholder="{{ 'ACTION1' | translate }}"
							optionValue="Id" dataKey="Id">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Action1)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Action2, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Action2, 'label')">{{ 'ACTION2' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Action2, 'borderInput')">
						<p-dropdown [options]="mtmaActions" optionLabel="Traslation" [ngClass]="dynamicInputTextWidth()"
							appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							panelStyleClass="text-center" formControlName="Action2" placeholder="{{ 'ACTION2' | translate }}"
							optionValue="Id" dataKey="Id">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Action2)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Rule, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Rule, 'label')">{{ 'GROUP' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Rule, 'borderInput')">
						<p-dropdown [options]="listRules" optionLabel="Name" [ngClass]="dynamicInputTextWidth()"
							appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							panelStyleClass="text-center" formControlName="Rule" placeholder="{{ 'GROUP' | translate }}"
							optionValue="Id" dataKey="Id">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Rule)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<p-panel header="{{ 'TEMPORARY_FROM'  | translate }}"
			*ngIf="!(keypadForm.value.Rule === null || keypadForm.value.Rule === undefined)"
			styleClass="p-panel-whitebg mb-3">
			<div class="grid">
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.StartDate, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.StartDate, 'label')">{{ 'START_DATE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.StartDate, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon" formControlName="StartDate" appendTo="body"
								placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
								[ngClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								[styleClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								inputStyleClass="pl-5 border-noround-right" [panelStyleClass]="dynamicDatepicker()">
							</p-calendar>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.StartDate)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.StartTime, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.StartTime, 'label')">{{ 'START_TIME' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.StartTime, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon" formControlName="StartTime" appendTo="body"
								timeOnly="true" [ngClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								[styleClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								inputStyleClass="pl-5 border-noround-right">
							</p-calendar>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.StartTime)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
				</div>
			</div>
		</p-panel>
		<p-panel header="{{ 'TEMPORARY_TO'  | translate }}"
			*ngIf="!(keypadForm.value.Rule === null || keypadForm.value.Rule === undefined)" styleClass="p-panel-whitebg">
			<div class="grid">
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.EndDate, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.EndDate, 'label')">{{ 'END_DATE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.EndDate, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon" formControlName="EndDate" appendTo="body"
								placeholder="dd/mm/yyyy" [minDate]="keypadForm.value.startDate" dateFormat="dd/mm/yy"
								[ngClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								[styleClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								inputStyleClass="pl-6 sm:pl-5 border-noround-right" [panelStyleClass]="dynamicDatepicker()">
							</p-calendar>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.EndDate)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'KEYPAD_DATE_WARNING_INVALID' |
						translate }}</small>
				</div>
				<div [ngClass]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.EndTime, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.EndTime, 'label')">{{ 'END_TIME' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.EndTime, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon" formControlName="EndTime" appendTo="body"
								timeOnly="true" [ngClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								[styleClass]="dynamicInputTextDesktopTabletWidth('inputText')"
								inputStyleClass="pl-5 border-noround-right">
							</p-calendar>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.EndTime)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'KEYPAD_DATE_WARNING_INVALID' |
						translate }}</small>
				</div>
			</div>
		</p-panel>

		<div class="grid mb-1 mx-1 flex justify-content-center align-items-center"
			[class]="(keypadForm.value.Rule === null || keypadForm.value.Rule === undefined) ? 'mt-8' : 'mt-3' ">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>